export interface AccessRow {
  format: string;
  content: string;
  pages: string;
}

export const accessRows: AccessRow[] = [
  { format: '📖 PDF de alta calidad', content: 'Los 6 Tomos del Sistema', pages: '+360 páginas' },
  { format: '💪 PDF imprimible', content: 'Los 6 Bonos completos', pages: '+180 páginas' }
];

export const accessChecks: string[] = [
  'PDF de alta calidad',
  'Imprimible en A4',
  'Optimizado para móvil y tablet',
  'Acceso inmediato sin esperas'
];
